'use client';

import { c as _c } from "react/compiler-runtime";
import { useState, useEffect, useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinnerThird } from '@awesome.me/kit-94e593bf23/icons/classic/light';
import { useCart } from '@/app/_lib/hooks/useCart';
import { useGlobalMessage } from '@/app/_lib/hooks';
import { useAppContext } from '@/app/_lib/_context';
const PromoCode = t0 => {
  const $ = _c(99);
  const {
    onPromotionChange,
    className
  } = t0;
  const {
    cart,
    promotion,
    applyPromotion,
    clearPromotion,
    isTradeCustomer
  } = useCart();
  const {
    openSignInModal
  } = useAppContext();
  const [promoCode, setPromoCode] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");
  const [isExpanded, setIsExpanded] = useState(false);
  const inputRef = useRef(null);
  const addGlobalMessage = useGlobalMessage();
  let t1;
  let t2;
  if ($[0] !== onPromotionChange || $[1] !== promotion) {
    t1 = () => {
      if (onPromotionChange) {
        onPromotionChange(promotion);
      }
    };
    t2 = [promotion, onPromotionChange];
    $[0] = onPromotionChange;
    $[1] = promotion;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  const prevRequiresLogin = useRef(null);
  let t3;
  let t4;
  if ($[4] !== addGlobalMessage || $[5] !== promotion) {
    t3 = () => {
      if (prevRequiresLogin.current === true && promotion && !promotion.requires_login) {
        addGlobalMessage({
          message: "You are now signed in.",
          messageType: "success"
        });
      }
      prevRequiresLogin.current = promotion ? !!promotion.requires_login : null;
    };
    t4 = [promotion, addGlobalMessage];
    $[4] = addGlobalMessage;
    $[5] = promotion;
    $[6] = t3;
    $[7] = t4;
  } else {
    t3 = $[6];
    t4 = $[7];
  }
  useEffect(t3, t4);
  let t5;
  let t6;
  if ($[8] !== isExpanded || $[9] !== promotion) {
    t5 = () => {
      if (isExpanded && !promotion && inputRef.current) {
        setTimeout(() => {
          inputRef.current?.focus();
        }, 100);
      }
    };
    t6 = [isExpanded, promotion];
    $[8] = isExpanded;
    $[9] = promotion;
    $[10] = t5;
    $[11] = t6;
  } else {
    t5 = $[10];
    t6 = $[11];
  }
  useEffect(t5, t6);
  let t7;
  if ($[12] !== addGlobalMessage || $[13] !== applyPromotion || $[14] !== promoCode) {
    t7 = async e => {
      e.preventDefault();
      if (!promoCode.trim()) {
        setError("Please enter a promotion code.");
        return;
      }
      setIsLoading(true);
      const response = await applyPromotion(promoCode.trim());
      if (response.success) {
        setPromoCode("");
        setIsExpanded(false);
        addGlobalMessage({
          message: "Promotion code applied!",
          messageType: "success"
        });
      } else {
        setError(response.message || "Promotion code not valid.");
      }
      setIsLoading(false);
    };
    $[12] = addGlobalMessage;
    $[13] = applyPromotion;
    $[14] = promoCode;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  const handleSubmit = t7;
  let t8;
  if ($[16] !== addGlobalMessage || $[17] !== clearPromotion) {
    t8 = async () => {
      setIsLoading(true);
      const success = await clearPromotion();
      if (success) {
        setError("");
        addGlobalMessage({
          message: "Promotion code removed.",
          messageType: "success"
        });
      }
      setIsLoading(false);
    };
    $[16] = addGlobalMessage;
    $[17] = clearPromotion;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  const handleRemove = t8;
  let t9;
  if ($[19] !== isExpanded) {
    t9 = () => {
      setIsExpanded(!isExpanded);
      setError("");
    };
    $[19] = isExpanded;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  const toggleExpanded = t9;
  if (isTradeCustomer) {
    if (!cart?.tradeBlockedPromotionCode) {
      return null;
    }
    const t10 = className || "";
    let t11;
    if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
      t11 = <span className="text-sm font-medium">Promotion Code:</span>;
      $[21] = t11;
    } else {
      t11 = $[21];
    }
    let t12;
    if ($[22] !== cart.tradeBlockedPromotionCode) {
      t12 = <div>{t11}<span className="text-sm ml-1 uppercase">{cart.tradeBlockedPromotionCode}</span></div>;
      $[22] = cart.tradeBlockedPromotionCode;
      $[23] = t12;
    } else {
      t12 = $[23];
    }
    let t13;
    if ($[24] !== handleRemove || $[25] !== isLoading) {
      t13 = <button type="button" onClick={handleRemove} disabled={isLoading} className="text-xs text-ink-light-gray-bg underline hover:text-dark transition-colors">Remove</button>;
      $[24] = handleRemove;
      $[25] = isLoading;
      $[26] = t13;
    } else {
      t13 = $[26];
    }
    let t14;
    if ($[27] !== t12 || $[28] !== t13) {
      t14 = <div className="flex items-center justify-between">{t12}{t13}</div>;
      $[27] = t12;
      $[28] = t13;
      $[29] = t14;
    } else {
      t14 = $[29];
    }
    let t15;
    if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
      t15 = <div className="text-xs text-red mt-1">Promotion codes are not valid for trade accounts.</div>;
      $[30] = t15;
    } else {
      t15 = $[30];
    }
    let t16;
    if ($[31] !== t10 || $[32] !== t14) {
      t16 = <div className={t10}>{t14}{t15}</div>;
      $[31] = t10;
      $[32] = t14;
      $[33] = t16;
    } else {
      t16 = $[33];
    }
    return t16;
  }
  const showCollapsed = !promotion && !isExpanded;
  const showExpanded = !promotion && isExpanded;
  const showApplied = !!promotion;
  const t10 = `relative ${className || ""}`;
  const t11 = `transition-opacity duration-300 ${showCollapsed ? "opacity-100" : "opacity-0 absolute inset-0 pointer-events-none"}`;
  let t12;
  if ($[34] !== toggleExpanded) {
    t12 = <button type="button" onClick={toggleExpanded} className="text-sm text-ink-light-gray-bg underline hover:text-dark">Apply Promotion Code</button>;
    $[34] = toggleExpanded;
    $[35] = t12;
  } else {
    t12 = $[35];
  }
  let t13;
  if ($[36] !== t11 || $[37] !== t12) {
    t13 = <div className={t11}>{t12}</div>;
    $[36] = t11;
    $[37] = t12;
    $[38] = t13;
  } else {
    t13 = $[38];
  }
  const t14 = `transition-opacity duration-700 ${showExpanded ? "opacity-100" : "opacity-0 absolute inset-0 pointer-events-none"}`;
  let t15;
  if ($[39] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = e_0 => setPromoCode(e_0.target.value);
    $[39] = t15;
  } else {
    t15 = $[39];
  }
  let t16;
  if ($[40] !== isLoading || $[41] !== promoCode) {
    t16 = <input ref={inputRef} type="text" id="promo_code_input" value={promoCode} onChange={t15} className="material-input peer pr-8" placeholder=" " disabled={isLoading} />;
    $[40] = isLoading;
    $[41] = promoCode;
    $[42] = t16;
  } else {
    t16 = $[42];
  }
  let t17;
  if ($[43] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <label htmlFor="promo_code_input" className="material-input-label peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-placeholder-shown:!text-ink-light-gray-bg peer-not-placeholder-shown:material-input-label-float">Promotion Code</label>;
    $[43] = t17;
  } else {
    t17 = $[43];
  }
  let t18;
  if ($[44] !== isLoading) {
    t18 = isLoading ? <FontAwesomeIcon icon={faSpinnerThird} className="animate-spin" /> : "Apply";
    $[44] = isLoading;
    $[45] = t18;
  } else {
    t18 = $[45];
  }
  let t19;
  if ($[46] !== isLoading || $[47] !== t18) {
    t19 = <button type="submit" disabled={isLoading} className="absolute right-0 top-1/2 -translate-y-1/2 text-xs text-ink-light-gray-bg hover:text-primary transition-colors disabled:opacity-50">{t18}</button>;
    $[46] = isLoading;
    $[47] = t18;
    $[48] = t19;
  } else {
    t19 = $[48];
  }
  let t20;
  if ($[49] !== t16 || $[50] !== t19) {
    t20 = <div className="material-input-group">{t16}{t17}{t19}</div>;
    $[49] = t16;
    $[50] = t19;
    $[51] = t20;
  } else {
    t20 = $[51];
  }
  let t21;
  if ($[52] !== handleSubmit || $[53] !== t20) {
    t21 = <form onSubmit={handleSubmit}>{t20}</form>;
    $[52] = handleSubmit;
    $[53] = t20;
    $[54] = t21;
  } else {
    t21 = $[54];
  }
  const t22 = `text-red text-xs transition-opacity duration-200 ${error ? "opacity-100" : "opacity-0"}`;
  const t23 = error || "\xA0";
  let t24;
  if ($[55] !== t22 || $[56] !== t23) {
    t24 = <span className={t22}>{t23}</span>;
    $[55] = t22;
    $[56] = t23;
    $[57] = t24;
  } else {
    t24 = $[57];
  }
  let t25;
  if ($[58] !== toggleExpanded) {
    t25 = <button type="button" onClick={toggleExpanded} className="text-xs text-ink-light-gray-bg underline hover:text-dark">Cancel</button>;
    $[58] = toggleExpanded;
    $[59] = t25;
  } else {
    t25 = $[59];
  }
  let t26;
  if ($[60] !== t24 || $[61] !== t25) {
    t26 = <div className="flex items-end justify-between mt-1">{t24}{t25}</div>;
    $[60] = t24;
    $[61] = t25;
    $[62] = t26;
  } else {
    t26 = $[62];
  }
  let t27;
  if ($[63] !== t14 || $[64] !== t21 || $[65] !== t26) {
    t27 = <div className={t14}>{t21}{t26}</div>;
    $[63] = t14;
    $[64] = t21;
    $[65] = t26;
    $[66] = t27;
  } else {
    t27 = $[66];
  }
  const t28 = `transition-opacity duration-300 ${showApplied ? "opacity-100" : "opacity-0 absolute inset-0 pointer-events-none"}`;
  let t29;
  if ($[67] === Symbol.for("react.memo_cache_sentinel")) {
    t29 = <span className="text-sm font-medium">Promotion Code:</span>;
    $[67] = t29;
  } else {
    t29 = $[67];
  }
  const t30 = promotion?.promotion_code;
  let t31;
  if ($[68] !== t30) {
    t31 = <div>{t29}<span className="text-sm ml-1 uppercase">{t30}</span></div>;
    $[68] = t30;
    $[69] = t31;
  } else {
    t31 = $[69];
  }
  let t32;
  if ($[70] !== isLoading) {
    t32 = isLoading ? <FontAwesomeIcon icon={faSpinnerThird} className="animate-spin" /> : "remove";
    $[70] = isLoading;
    $[71] = t32;
  } else {
    t32 = $[71];
  }
  let t33;
  if ($[72] !== handleRemove || $[73] !== isLoading || $[74] !== t32) {
    t33 = <button type="button" onClick={handleRemove} className="text-xs text-ink-light-gray-bg underline hover:text-dark transition-colors" disabled={isLoading}>{t32}</button>;
    $[72] = handleRemove;
    $[73] = isLoading;
    $[74] = t32;
    $[75] = t33;
  } else {
    t33 = $[75];
  }
  let t34;
  if ($[76] !== t31 || $[77] !== t33) {
    t34 = <div className="flex items-center justify-between">{t31}{t33}</div>;
    $[76] = t31;
    $[77] = t33;
    $[78] = t34;
  } else {
    t34 = $[78];
  }
  let t35;
  if ($[79] !== cart || $[80] !== promotion) {
    t35 = promotion?.messages && promotion.messages.length > 0 && <div className="mt-1">{promotion.messages.map((message, index) => {
        const isDiscountAppliedMessage = message.toLowerCase().includes("discount applied");
        if (isDiscountAppliedMessage && (!cart?.discount || cart.discount === 0)) {
          return null;
        }
        return <div key={index} className={`text-xs ${promotion.requires_login ? "text-light" : "text-green-600"}`}>{message}</div>;
      })}</div>;
    $[79] = cart;
    $[80] = promotion;
    $[81] = t35;
  } else {
    t35 = $[81];
  }
  let t36;
  if ($[82] !== cart?.hasSaleItems || $[83] !== promotion) {
    t36 = promotion && !promotion.requires_login && cart?.hasSaleItems && <div className="mt-1 text-xs text-red lowercase">some items in your cart do not qualify for the promotion</div>;
    $[82] = cart?.hasSaleItems;
    $[83] = promotion;
    $[84] = t36;
  } else {
    t36 = $[84];
  }
  let t37;
  if ($[85] !== openSignInModal || $[86] !== promotion?.requires_login) {
    t37 = promotion?.requires_login && <div className="mt-1 text-xs text-light"><button type="button" onClick={openSignInModal} className="underline text-primary">Sign in</button> to apply this discount.</div>;
    $[85] = openSignInModal;
    $[86] = promotion?.requires_login;
    $[87] = t37;
  } else {
    t37 = $[87];
  }
  let t38;
  if ($[88] !== t28 || $[89] !== t34 || $[90] !== t35 || $[91] !== t36 || $[92] !== t37) {
    t38 = <div className={t28}>{t34}{t35}{t36}{t37}</div>;
    $[88] = t28;
    $[89] = t34;
    $[90] = t35;
    $[91] = t36;
    $[92] = t37;
    $[93] = t38;
  } else {
    t38 = $[93];
  }
  let t39;
  if ($[94] !== t10 || $[95] !== t13 || $[96] !== t27 || $[97] !== t38) {
    t39 = <div className={t10}>{t13}{t27}{t38}</div>;
    $[94] = t10;
    $[95] = t13;
    $[96] = t27;
    $[97] = t38;
    $[98] = t39;
  } else {
    t39 = $[98];
  }
  return t39;
};
export default PromoCode;